import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name square-off
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjAuNCAyMC40YTIgMiAwIDAxLTEuNC42SDVhMiAyIDAgMDEtMi0yVjVhMiAyIDAgMDEuNTktMS40MSIgLz4KICA8cGF0aCBkPSJNMjEgMTUuM1Y1YTIgMiAwIDAwLTItMkg4LjciIC8+CiAgPHBhdGggZD0iTTIyIDIyIDIgMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/square-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const SquareOff: IconNode = [
  ['path', { d: 'M20.4 20.4a2 2 0 01-1.4.6H5a2 2 0 01-2-2V5a2 2 0 01.59-1.41' }],
  ['path', { d: 'M21 15.3V5a2 2 0 00-2-2H8.7' }],
  ['path', { d: 'M22 22 2 2' }],
];

export default SquareOff;
